// extracted by mini-css-extract-plugin
module.exports = {"photoDetail":"detail_photoDetail__1UDlU","photos":"detail_photos__1om67","photo":"detail_photo__8rCaX"};